<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import { customChartLegendCallback } from "@/composables/customChartLegend.js";
import AdvancedDoughnutChart from "@/components/app/charts/AdvancedDoughnutChart.vue";

const props = defineProps({
  sourceData: {
    type: Object,
    required: true,
  },

  radius: {
    type: Number,
    default: 150,
  },
});

const htmlLegend = ref(null);
const chart = ref({
  labels: null,
  data: null,
  backgroundColors: null,
});
const options = ref({
  responsive: false,
  maintainAspectRatio: true,
  animation: {
    duration: 2000,
  },
});

const totalHomes = ref(0);

const chartStyle = computed(() => {
  return {
    width: `${props.radius}px`,
    height: `${props.radius}px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});

function onChartRendered(payload) {
  htmlLegend.value = payload;
}

watch(
  () => props.sourceData,
  () => {
    let backgroundColors = [];
    let values = [];
    let th = 0;

    Object.values(props.sourceData).forEach((data) => {
      backgroundColors.push(data.color ? data.color : "#CCCCCC");
      values.push(data.val);
      th += data.val;
    });

    chart.value.backgroundColors = backgroundColors;
    chart.value.labels = Object.keys(props.sourceData);
    chart.value.data = values;

    totalHomes.value = th;
  },
  { immediate: true, deep: true }
);

const innerChartText: IInnerChartText[] = [
  { value: "Totaal", bold: false },
  { value: totalHomes.value, bold: true },
  { value: "woningen", bold: false },
];
</script>

<template>
  <div class="vue-chart building-functions">
    <AdvancedDoughnutChart :innerText="innerChartText" :data-set="chart" :options="options" :style="chartStyle" @chart-rendered="onChartRendered"></AdvancedDoughnutChart>
  </div>
</template>
